module.exports = __webpack_public_path__ + "img/background@3x.0405944d.png";